import { gql } from 'apollo-angular';

export const CreateNewCampaningDocument = gql`
  mutation createNewCampanign($input: CreateMarketingCampaignInputGraphql!) {
    createNewCampanign(input: $input) {
      funnelId
    }
  }
`;
